import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadableGtmHead from './GtmHeadLoadable';
import LoadableGtmBody from './GtmBodyLoadable';
import HeaderNavNewVersionNew from '../navigation/HeaderNavNewVersionNew';
import FooterNavNewUpdateVersionNew from '../navigation/FooterNavNewUpdateVersionNew';

class MainContainer extends Component {
  render() {
    const { children } = this.props;

    return (
      <div className="relative">
        {/* Lazy-load GTM script in head section */}
        <LoadableGtmHead gtmId="GTM-M7VJ3PV" />

        <HeaderNavNewVersionNew />

        {children}

        <FooterNavNewUpdateVersionNew />

        {/* Lazy-load GTM script in body section */}
        <LoadableGtmBody gtmId="GTM-M7VJ3PV" />
      </div>
    );
  }
}

MainContainer.propTypes = {
  children: PropTypes.node,
};

export default MainContainer;